import React from "react";

import { Container } from "./styles";

export default function Heading({ children, back = true }) {
	return (
		<Container>
			{back && (
				<button onClick={() => window.history.back()}>
					<img
						loading='lazy'
						src={require("@/assets/img/back-black@2x.png").default}
						alt='icone voltar'
					/>
				</button>
			)}
			<h1>
				<span>Programa Fidelidade Gerioox</span>
				{children}
			</h1>
		</Container>
	);
}
